import { render, staticRenderFns } from "./FlowTriggers.vue?vue&type=template&id=2a18e1ee&scoped=true&"
import script from "./FlowTriggers.vue?vue&type=script&lang=js&"
export * from "./FlowTriggers.vue?vue&type=script&lang=js&"
import style0 from "./FlowTriggers.vue?vue&type=style&index=0&id=2a18e1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18e1ee",
  null
  
)

export default component.exports